export const setEventEndDate = value => ({
  type: 'EVENT_END_DATE',
  value
});

export const setEventApplicationLogoWebsite = value => ({
  type: 'EVENT_APPLICATION_LOGO_WEBSITE',
  value
});

export const setEventApplicationLogoMobile = value => ({
  type: 'EVENT_APPLICATION_LOGO_MOBILE',
  value
});